import styled from '@emotion/styled';
import { Stack } from '@mui/material';
import { shouldForwardProps } from '../../../utils';
import { WavingHandOutlined } from '@mui/icons-material';

const IntroductionContainer = styled(Stack, shouldForwardProps)`
    background-color: ${({ theme }) => theme.colors.outlineVariant};
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    margin-left: ${({ theme }) => theme.spacing(3)};
    margin-right: ${({ theme }) => theme.spacing(3)};
`;

const GreetingIcon = styled(WavingHandOutlined)`
    color: ${({ theme }) => theme.colors.secondaryDark};
    height: 138px;
    width: 138px;
`;

export { IntroductionContainer, GreetingIcon };
